import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { HeaderAppearanceEvents } from './state/header.state';
import { injectDispatch } from '@ngrx/signals/events';

@Component({
  selector: 'ticketing-login-redirect',
  imports: [],
  templateUrl: './login-redirect.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginRedirectComponent implements OnInit {
  private readonly dispatch = injectDispatch(HeaderAppearanceEvents);

  ngOnInit(): void {
    this.dispatch.requestHero();
  }
}
